var _path, _rect, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCurly = function SvgCurly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    viewBox: "0 0 1440 298",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M-133 5L1322 5C1377.23 5 1422 49.7715 1422 105V112V119C1422 174.228 1377.23 219 1322 219H1299.15",
    stroke: "url(#paint0_linear_x)",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    vectorEffect: "non-scaling-stroke",
    x: 1297,
    y: 97,
    width: 225,
    height: 196,
    rx: 98,
    stroke: "url(#paint1_linear_x)",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_x",
    x1: 1422,
    y1: 5.00009,
    x2: 376.035,
    y2: 849.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7156B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_x",
    x1: 1522,
    y1: 97.0001,
    x2: 1276,
    y2: 128.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF1D2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7156B"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/curly.be0eb864.svg";
export { ForwardRef as ReactComponent };